import type { PortfolioDraft, PortfolioDraftReview } from '../../types/api.js';

function defaultPortfolioDraft(): PortfolioDraft {
  return {
    kind: 'custom',
    title: '',
    description: '',
    budgetRub: '',
    specs: { cpu: '', gpu: '', motherboard: '', ram: '', psu: '', storage: '', caseName: '' },
    review: { author: '', rating: 5, text: '' },
    images: []
  };
}

let portfolioDraft: PortfolioDraft = defaultPortfolioDraft();

export function getPortfolioDraft(): PortfolioDraft {
  return portfolioDraft;
}

export function resetPortfolioDraft(overrides?: Partial<PortfolioDraft>): PortfolioDraft {
  portfolioDraft = defaultPortfolioDraft();
  if (overrides && typeof overrides === 'object') {
    Object.assign(portfolioDraft, overrides);
    if (overrides.specs) portfolioDraft.specs = Object.assign({}, portfolioDraft.specs, overrides.specs);
    if (overrides.review) portfolioDraft.review = Object.assign({}, portfolioDraft.review, overrides.review);
    if (overrides.images) portfolioDraft.images = overrides.images.slice();
  }
  return portfolioDraft;
}

export function setPortfolioDraftKind(kind: string): void {
  portfolioDraft.kind = kind;
}

export type { PortfolioDraft, PortfolioDraftReview };
